
// config.js is generated at deploy time by the StaticAssetUploaderLambdaFunction and
// uploaded to the static website bucket as /config.js. index.html loads it before the
// React bundle, setting window.config with the real resource IDs for the deployed
// environment (restApiId, identityPoolId, userPoolId, userPoolClientId, artifactBucket).
//
// NOTE: apiUserPoolId and apiUserPoolClientId are NOT managed by the CloudFormation stack
// and must be set manually in config.js via a separate deployment process, or added to
// window.config by another mechanism before the React bundle initialises.
export function initResourcesConfig() {
	if (!window.config) {
		throw new Error(
			'window.config is not set. ' +
			'The /config.js file must be present in the static website bucket and loaded before the React bundle. ' +
			'Re-deploy the stack to regenerate config.js via the StaticAssetUploaderLambdaFunction.'
		);
	}
};

// Set by the StaticAssetUploader custom resource from PortalEnvironmentConfig.enableAIAssistant.
// Missing/falsy defaults to disabled, so older config.js files without this key stay hidden.
export function isAIAssistantEnabled() {
	return Boolean(window.config) && window.config.enableAIAssistant === true;
}

// Set by the StaticAssetUploader custom resource. Missing defaults to disabled.
export function isPolicyStateChangeEnabled() {
	return Boolean(window.config) && window.config.enablePolicyStateChange === true;
}
